import { fetchWrapRPC } from '../services/api';
import {
  ListSecretsRequest,
  ListSecretsResponse,
  SecretService_ListSecrets,
} from './gen/ai/h2o/securestore/v1/secret_service_pb';
import {
  RevealSecretVersionValueRequest,
  RevealSecretVersionValueResponse,
  SecretVersionService_RevealSecretVersionValue,
} from './gen/ai/h2o/securestore/v1/secret_version_service_pb';
import { RPC } from './gen/runtime';

export const listSecrets = (
  secureStoreApiUrl: string,
  request: ListSecretsRequest,
  requestInit?: { signal?: AbortSignal }
): Promise<ListSecretsResponse> => {
  return fetchWrapRPC(SecretService_ListSecrets, { basePath: `${secureStoreApiUrl}` })(
    request,
    requestInit
  ) as Promise<ListSecretsResponse>;
};

export const revealSecretVersionValue = (
  secureStoreApiUrl: string,
  request: RevealSecretVersionValueRequest,
  requestInit?: { signal?: AbortSignal }
): Promise<RevealSecretVersionValueResponse> => {
  return fetchWrapRPC(
    SecretVersionService_RevealSecretVersionValue as RPC<
      RevealSecretVersionValueRequest,
      RevealSecretVersionValueResponse
    >,
    {
      basePath: `${secureStoreApiUrl}`,
    }
  )(request, requestInit);
};
